import React, { useState, useEffect, useRef } from "react";
import { CSVReader } from "react-papaparse";
// import { BASE_URL } from "../env";
import { developAxios } from "../axios.config";
import "./AttendanceUpload.css";

const AttendanceUpload = () => {
	const buttonRef = React.createRef();
	const [csvdata, setcsvdata] = useState(null);
	const [courses, setCourses] = useState([]);
	const [course, setcourse] = useState("");
	const [date, setDate] = useState("");
	const [batches, setBatches] = useState([]);
	// const { CSVReader } = useCSVReader();

	const batchName = useRef(null);

	useEffect(() => {
		developAxios("")
			.get("/getallCourse")
			.then(({ data }) => setCourses(data.courses))
			.catch((err) => console.log(err));
	}, []);

	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get("/powerbi/getBatches")
			.then(({ data }) => setBatches(data))
			.catch((err) => console.log(err));
	}, []);

	const handleOnFileLoad = (data) => {
		console.log("---------------------------");
		setcsvdata(data);
		console.log("---------------------------");
	};

	const handleOnError = (err, file, inputElem, reason) => {
		console.log(err);
	};

	const handleOnRemoveFile = (data) => {
		console.log("---------------------------");
		console.log(data);
		console.log("---------------------------");
	};

	const handleOpenDialog = (e) => {
		// Note that the ref is set async, so it might be null at some point
		if (buttonRef.current) {
			buttonRef.current.open(e);
		}
	};

	const handleRemoveFile = (e) => {
		// Note that the ref is set async, so it might be null at some point
		if (buttonRef.current) {
			buttonRef.current.removeFile(e);
		}
	};

	const uploadcsvdata = () => {
		console.log(date, batchName.current.value, course);
		let data_arr = [];
		for (let i = 1; i < csvdata.length; i++) {
			data_arr.push({
				email: csvdata[i].data[0].trim().toLowerCase(),
				attendance:
					csvdata[i].data[1].trim() === "1" ||
					csvdata[i].data[1].trim() === "P",
			});
		}

		console.log(data_arr);

		developAxios(localStorage.getItem("token"))
			.post("/upload-attendance", {
				data_arr,
				course,
				date,
				batch: batchName.current.value,
			})
			.then((res) => alert("Attendance upload successful"))
			.catch((err) => console.warn(err));
	};

	return (
		<>
			<div className="row">
				<div className="col-4 attendance-col-11">
					<div className="container mt-5">
						<div className="logo">
							<img
								src="https://cantileverlabs-quiz-answer-images.s3.ap-south-1.amazonaws.com/1656916229474_cantilever-logo-final-black.png"
								alt="logo"
							/>
						</div>
						<div>
							<img
								className="arrow-icon"
								src="https://cantileverlabs-quiz-answer-images.s3.ap-south-1.amazonaws.com/1656916147807_Group%209188.png"
								alt="icons"
							/>
						</div>
						<p className="heading1">Upload Attendance.</p>
						<p className="heading2">
							The colums in CSV must be in following order:
						</p>
						<div className="sec-1">
							<p>0:Email</p>
							<p>0:Attendance(0/1)</p>
						</div>
					</div>
				</div>
				<div className="col-8 attendance-col-22">
					<form>
						<div className="form-group">
							<label className="upload-lable-1" htmlFor="course">
								Choose the course
							</label>
							<select
								className="upload-select-1"
								aria-label="Default select example"
								value={course}
								onChange={(e) => {
									setcourse(e.target.value);
									console.log(course);
								}}
								id="course"
							>
								<option value="">Select Course</option>
								{courses.map((val) => {
									return (
										<option key={val?._id} value={val?._id}>
											{val?.name}
										</option>
									);
								})}
							</select>
						</div>
						<div className="form-group">
							<label className="upload-lable-2" htmlFor="date">
								Date of Attendance
							</label>
							<br />
							<input
								className="upload-select-2"
								type="datetime-local"
								name="date"
								id="date"
								value={date}
								onChange={(e) => setDate(e.target.value)}
							/>
						</div>
						<div className="form-group">
							<label
								className="upload-lable-3"
								htmlFor="batchName"
							>
								Select Batch Name
							</label>
							<select
								className="upload-select-3"
								aria-label="Default select example"
								name="batchName"
								id="batchName"
								ref={batchName}
							>
								{batches.map((batch) => (
									<option value={batch._id}>
										{batch.name}
									</option>
								))}
							</select>
						</div>
						<div className="form-group">
							<CSVReader
								ref={buttonRef}
								onFileLoad={handleOnFileLoad}
								onError={handleOnError}
								noClick
								noDrag
								onRemoveFile={handleOnRemoveFile}
							>
								{({ file }) => (
									<aside className="upload-input">
										<button
											type="button"
											onClick={handleOpenDialog}
											className="browse-file-btn"
										>
											Browse file
										</button>
										<div className="upload-file-btn">
											{file && file.name}
										</div>
										<button
											className="upload-arrow-btn"
											onClick={handleRemoveFile}
										>
											<img
												src="https://cantileverlabs-quiz-answer-images.s3.ap-south-1.amazonaws.com/1656916147807_Group%209188.png"
												alt=""
											/>
										</button>
									</aside>
								)}
							</CSVReader>
						</div>
						<div className="form-group">
							<div
								className="btn btn-primary upload-btn"
								onClick={uploadcsvdata}
							>
								{" "}
								Upload{" "}
							</div>
						</div>
					</form>
				</div>
			</div>
		</>
	);
};

export default AttendanceUpload;
